import DatePicker from '../common/DatePicker';
import { Drawer, Button } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import { useTranslation } from '../../hook/useTranslation';

function BirthDatePickerDialog({
  open,
  onClose = () => {},
  onConfirm = () => {},
  birthInput,
  setBirthInput,
}) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        if (onClose) (onClose as any)(event, reason);
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
    >
      <div className="w-full p-5 min-h-[200px] text-[#1C1C1C] text-[20px] font-[700] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden">
        <div className="w-full flex justify-end items-center mb-3">
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full flex justify-center items-center mb-3">
          <DatePicker
            selectedDate={birthInput}
            setSelectedDate={(value: any) => {
              setBirthInput(value);
            }}
          />
        </div>
        <Button
          variant="contained"
          className="w-full"
          onClick={onConfirm}
          disabled={birthInput?.length < 8}
        >
          {t('upload.caution.confirm_btn')}
        </Button>
      </div>
    </Drawer>
  );
}

export default BirthDatePickerDialog;
